// extracted by mini-css-extract-plugin
export default {"emptyFavs":"Favorites_emptyFavs__TG3R5","emptyFavsBtns":"Favorites_emptyFavsBtns__-4n5e","favoriteImg":"Favorites_favoriteImg__9ciAm"};